/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// Soft UI Context Provider
import { SoftUIControllerProvider } from "context";
import { UserProvider } from "context/user";
import { AgencyProvider } from "context/agency";
import { KnowledgeBaseProvider } from "context/knowledgebaseContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <SoftUIControllerProvider>
      <UserProvider>
        <AgencyProvider>
          <KnowledgeBaseProvider>
            <App />
          </KnowledgeBaseProvider>
        </AgencyProvider>
      </UserProvider>
    </SoftUIControllerProvider>
  </BrowserRouter>
);
